import CryptoJS from "crypto-js";
import { isTrue } from "./commonHelper";
import { toastMessage } from "./toastMessageHelper";

// Ensure the environment variable is set correctly
const SECRET_KEY = process.env.REACT_APP_CRYPTO_SECRET_KEY;

const checkSecretKey = () => {
  if (!SECRET_KEY) {
    console.error("Secret key is missing");
    return false;
  }
  return true;
};

// Encrypt function
export const encryptData = (data, isUrl = false) => {
  if (!checkSecretKey()) return null;
  try {
    let encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      SECRET_KEY
    ).toString();

    if (isTrue(isUrl)) {
      encryptedData = encodeURIComponent(encryptedData);
    }

    return encryptedData;
  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
};

export const encryptDataHandler = (data) => {
  return CryptoJS.AES.encrypt(
    JSON.stringify(data),
    process.env.REACT_APP_SECRET_KEY
  ).toString();
};

// Decrypt function
export const decryptData = (encryptedData, isUrl = false) => {
  if (!checkSecretKey()) return null;
  try {
    if (!encryptedData) {
      console.error("Encrypted data is missing");
      return null;
    }

    let decodedData = encryptedData;
    if (isTrue(isUrl)) {
      decodedData = decodeURIComponent(encryptedData);
    }

    const decryptedBytes = CryptoJS.AES.decrypt(decodedData, SECRET_KEY);
    const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);

    return JSON.parse(decryptedData);
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};

export const handleDecryptionParams = (
  encryptedParam,
  setData,
  message = ""
) => {
  // Check if encryptedParam exists
  if (!encryptedParam) {
    console.error("Encrypted parameter is missing");
    setData(""); // Reset the search params if parameter is missing
    toastMessage(message, "warning", `toast_error_message_${message}`);
    return null;
  }

  // Try to decrypt the parameter
  const decryptedData = decryptData(encryptedParam, true);

  if (!decryptedData) {
    // If decryption fails, reset the search params
    setData("");
    console.error("Decryption failed, resetting search params");
    toastMessage(message, "warning", `toast_error_message_${message}`);
    return null;
  }

  console.log(decryptedData, "decryptedData---------->");

  // Return the successfully decrypted data
  return decryptedData;
};

export const handleEncryptionParams = (data, paramsData) => {
  // Encrypt the data
  const encryptParamsData = encryptData(data, true);
  // Set encrypted data in URL parameters
  if (paramsData) {
    paramsData.set("data", encryptParamsData);
    return paramsData;
  } else {
    return encryptParamsData;
  }
};

export function generateUniqueId() {
  return crypto.randomUUID();
}
